"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.useCurrentPath = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Body_scss_json_1 = __importDefault(require("./Body.scss.json"));
require("./Body.scss");
function getPageClass(currentRoute) {
    let pageClassName = currentRoute.substring(1).replace(/[-\:\/]+/g, '_');
    return pageClassName || 'home';
}
const useCurrentPath = (appRoutes) => {
    const location = (0, react_router_dom_1.useLocation)();
    let routes = Object.keys(appRoutes).map((key) => {
        return {
            path: appRoutes[key].path,
        };
    });
    const matches = (0, react_router_dom_1.matchRoutes)(routes, location);
    return matches && matches.length > 0 ? matches[0].route.path : null;
};
exports.useCurrentPath = useCurrentPath;
const logged = new Set();
exports.Body = react_1.default.memo(({ children, pageStyles = {}, className = '', routes }) => {
    //calculate the name of a css class from the current route
    //these can then be defined in Content.scss to overwrite for example the background color of the entire page
    let currentRoute = (0, exports.useCurrentPath)(routes) || '';
    let [pageClass, setPageClass] = (0, react_1.useState)(getPageClass(currentRoute));
    // const location = useLocation();
    let pageClassStyleObject = pageStyles || Body_scss_json_1.default;
    let pageClassFromCssModule = pageClassStyleObject[pageClass] ||
        pageClassStyleObject['pageDefault'] ||
        Body_scss_json_1.default['pageDefault'];
    if (pageStyles &&
        !pageStyles[pageClass] &&
        typeof window !== 'undefined' &&
        !logged.has(pageClass)) {
        logged.add(pageClass);
        console.info(`No page css class defined for '.${pageClass}' in <Body pageStyles />. Using '.pageDefault' instead`);
    }
    (0, react_1.useEffect)(() => {
        // runs on location, i.e. route, change
        setPageClass(getPageClass(currentRoute));
    }, [currentRoute]);
    return (react_1.default.createElement("div", { className: pageClassFromCssModule + (className ? ' ' + className : '') }, children));
});
//# sourceMappingURL=Body.js.map